var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"px-8"},[_c('rir-tabs',{staticClass:"mb-5",attrs:{"items":_vm.routerList,"value":_vm.$route.name},on:{"change":_vm.changeRoute}}),_c('router-view',{key:_vm.$route.name})],1)}
var staticRenderFns = []

export { render, staticRenderFns }